import { Inline, Skeleton } from '@omnipresentgroup/design-system';
import { toSentenceCase } from '@omnipresentgroup/helpers';
import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';

import { CompanyManagerActionsCell } from '../components';
import { ColumnHeaders, type CompanyManager } from '../types';

export const useCompanyManagersTableConfig = ({
  companyId,
}: {
  companyId: string;
}) => {
  const columnHelper = useMemo(() => createColumnHelper<CompanyManager>(), []);

  const columns = useMemo(
    () => [
      columnHelper.accessor('name', {
        cell: (info) => info.getValue(),
        header: () => ColumnHeaders.name,
      }),
      columnHelper.accessor('jobTitle', {
        cell: (info) => info.getValue(),
        header: () => ColumnHeaders.jobTitle,
      }),
      columnHelper.accessor('department', {
        cell: (info) => info.getValue(),
        header: () => ColumnHeaders.department,
      }),
      columnHelper.accessor('email', {
        cell: (info) => info.getValue(),
        header: () => ColumnHeaders.email,
      }),
      columnHelper.accessor('role', {
        cell: (info) => toSentenceCase(info.getValue()),
        header: () => ColumnHeaders.role,
      }),
      columnHelper.display({
        id: 'actions',
        cell: (info) => (
          <CompanyManagerActionsCell
            manager={info.row.original}
            companyId={companyId}
          />
        ),
        header: () => ColumnHeaders.actions,
        size: 40,
        enableSorting: false,
        meta: {
          onClickStopPropagation: true,
          loader: (
            <Inline align="flex-end" gap="8">
              <Skeleton height={24} width={24} />
            </Inline>
          ),
        },
      }),
    ],
    [columnHelper, companyId],
  );

  return {
    columns,
    columnHelper,
  };
};
